import React, { useCallback, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Stack } from "@mui/material";

import { schema } from "../../../../schemas/createTeam";
import { useUsers } from "../../../../reactQuery/users";
import { createTeam } from "../../../../services/apiTeam";
import { useResponsive } from "../../../../hooks/useResponsive";
import {
  RFHTextField as RHFTextField,
  RFHAutocomplete,
} from "../../../../components/RFH";
import { CustomButton } from "../../../../components/Button/Button";
import useMutate from "../../../../hooks/useMutate";
import { getCreateTeamUserOptions } from "../utils/userManagementUtils";

function CreateTeamForm({ onClose }) {
  const [loading, setLoading] = React.useState(false);
  const { users } = useUsers();
  const isMobile = useResponsive("down", "md");
  // React Hook Form
  const { handleSubmit, ...methods } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      user_ids: [],
    },
  });

  const { mutate } = useMutate(createTeam,["teams", "users"],() => {},
    () => {
      setLoading(false);
      //toast.success(res.data.message);
      onClose();
    },
    () => {
      //toast.error(error.response.data.message);
      setLoading(false);
    });

  const submit = useCallback(
    (data) => {
      setLoading(true);      
      mutate({ ...data });
    },
    [mutate]
  );

  const userOptions = useMemo(() => {
    return getCreateTeamUserOptions(users?.data?.data?.responseData || []);
  }, [users]);

  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        onSubmit={handleSubmit(submit)}
        noValidate
        className="create-team-form"
      >
        <Stack spacing={3}>
          <RHFTextField
            name={"team_name"}
            label={"Team Name"}
            required
            className="create-team-form-textfield"
          />
          <RFHAutocomplete
            name="user_ids"
            options={userOptions}
            multiple={true}
            disableCloseOnSelect={true}
            isCheckbox={true}
            label="Invite People to your Team"
          />
          <Box className="create-team-form-button-container d-flex">
            <CustomButton
              type="submit"
              variant="contained"
              className="create-team-form-submit-button"
              disabled={loading}
            >
              Create
            </CustomButton>
            <CustomButton
              variant="outlined"
              className="create-team-form-cancel-button"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </CustomButton>
          </Box>
        </Stack>
      </Box>
    </FormProvider>
  );
}

export default React.memo(CreateTeamForm);
